/**
 * <pix-parcelamento>
 * Mantém a linha de Pix/parcelamento sincronizada com o preço ao trocar a variação.
 *
 * O tema já faz um fetch da seção ao trocar a variação (variant:update) e devolve
 * o HTML novo em event.detail.data.html — que JÁ contém o pix recalculado no servidor.
 * Aqui só copiamos esse valor pronto para o elemento atual. Zero requisição nova:
 * o parcelamento passa a atualizar no mesmo instante que o preço, sem "lag".
 */
class PixParcelamento extends HTMLElement {
  connectedCallback() {
    this._onVariantUpdate = this.onVariantUpdate.bind(this);
    document.addEventListener('variant:update', this._onVariantUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('variant:update', this._onVariantUpdate);
  }

  onVariantUpdate(event) {
    const data = event && event.detail && event.detail.data;
    if (!data || !data.html) return;

    const productId = this.dataset.productId;
    const blockId = this.dataset.blockId;
    let replacement = null;

    if (blockId) {
      replacement = data.html.querySelector('pix-parcelamento[data-block-id="' + blockId + '"]');
    }

    if (!replacement) {
      const candidates = data.html.querySelectorAll('pix-parcelamento');
      for (let i = 0; i < candidates.length; i++) {
        const c = candidates[i];
        if (!productId || c.dataset.productId === productId) {
          replacement = c;
          break;
        }
      }
      if (!replacement && candidates.length) replacement = candidates[0];
    }

    if (replacement && replacement.innerHTML.trim() !== '') {
      this.innerHTML = replacement.innerHTML;
      if (replacement.dataset.productId) this.dataset.productId = replacement.dataset.productId;
    }
  }
}

if (!customElements.get('pix-parcelamento')) {
  customElements.define('pix-parcelamento', PixParcelamento);
}